import React from 'react';
import DepartmentPaymentRequests from '../../components/DepartmentPaymentRequests';

const OperationsPaymentRequests = () => {
  return <DepartmentPaymentRequests department="OPERATIONS" departmentLabel="Operations Dept" />;
};

export default OperationsPaymentRequests;
